import * as React from 'react';

const ITALICIZED_TEXT = /{i}.+?{\/i}/;
const BOLD_TEXT = /{bold}.+?{\/bold}/;
const LINK_TEXT = /{link-(\d+)}.+?{\/link-(\d+)}/;
const SUPER_TEXT = /{super}.+?{\/super}/;

export function stylize(str: string, navCopy?: string[]): React.ReactNode | React.ReactNode[] {
  const italics_match = str.match(ITALICIZED_TEXT);
  const bold_match = str.match(BOLD_TEXT);
  const link_match = str.match(LINK_TEXT);
  const super_match = str.match(SUPER_TEXT);
  if (italics_match) {
    const [before, ...rest] = str.split(italics_match[0]);
    return [
      before,
      <i>{italics_match[0].replace('{i}', '').replace('{/i}', '')}</i>,
      stylize(rest.join(italics_match[0])),
    ];
  } else if (bold_match) {
    const [before, ...rest] = str.split(bold_match[0]);
    return [
      before,
      <span className="bold">{bold_match[0].replace('{bold}', '').replace('{/bold}', '')}</span>,
      stylize(rest.join(bold_match[0])),
    ];
  } else if (super_match) {
    const [before, ...rest] = str.split(super_match[0]);
    return [
      before,
      <span className="super">{super_match[0].replace('{super}', '').replace('{/super}', '')}</span>,
      stylize(rest.join(super_match[0])),
    ];
  } else if (link_match && navCopy) {
    const [before, ...rest] = str.split(link_match[0]);
    const LINK_OPENING_REGEX: RegExp = /{link-(\d+)}/;
    const LINK_CLOSING_REGEX: RegExp = /{\/link-(\d+)}/;
    const linkStr: string = link_match[0];
    const linkOpenRegex: string = LINK_OPENING_REGEX.exec(linkStr)?.[0] || '';
    const linkCloseRegex: string = LINK_CLOSING_REGEX.exec(linkStr)?.[0] || '';
    const linkIndex = LINK_OPENING_REGEX.exec(linkStr)?.[1];
    const nav = navCopy[parseInt(linkIndex || '1') - 1];
    return [
      before,
      <a href={nav} target="_blank" rel="noopener noreferrer">{link_match[0].replace(linkOpenRegex, '').replace(linkCloseRegex, '')}</a>,
      stylize(rest.join(''), navCopy),
    ];
  }

  return str;
}